import React from "react";
import { useTranslation } from "react-i18next";
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaLink } from "react-icons/fa";
import { Link } from "react-router-dom";
import { FaHandshakeSimple } from "react-icons/fa6";
import SocialNetworkLinks from "../social-network-links/SocialNetworkLinks";
import ShadowEffect from "../../UI/shadowEffect";

function ContactInfo() {
  const { t } = useTranslation();

  return (
    <div>
      <h3 className="text-lg md:text-xl font-semibold mb-4 text-baseBlue flex items-center justify-center md:justify-start">
        <FaMapMarkerAlt className="mr-2 text-baseBlue" /> {t("contactUs")}
      </h3>
      <div className="text-sm text-gray-800 space-y-2 flex flex-col items-center md:items-start">
        <p>{t("giorgitsminda")}</p>
        <p>{t("SagarejoGeorgia3800")}</p>
        <p className="flex items-center">
          <FaEnvelope className="mr-2 text-baseBlue" />
          <a href="mailto:awcgarejelebi@gmail.com" className="hover:underline">
            awcgarejelebi@gmail.com
          </a>
        </p>
        <div className="flex items-center">
          <FaPhone className="mr-2 text-baseBlue" />
          <div className="flex flex-col">
            <a href="tel:+995598720440" className="hover:underline">
              +995 (598) 720 440
            </a>
            <a href="tel:+995598314917" className="hover:underline">
              +995 (598) 314 917
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

function QuickLinks() {
  const { t } = useTranslation();
  return (
    <div>
      <h3 className="text-lg md:text-xl font-semibold mb-4 text-baseBlue flex flex-col items-center md:items-start">
        <div className="flex items-center justify-center md:justify-start">
          <FaHandshakeSimple className="mr-2 text-baseBlue" />
          {t("termsAndServices")}
        </div>
      </h3>
      <div className="flex flex-col text-sm space-y-2 items-center md:items-start">
        <Link
          to={`/privacy-policy`}
          className="hover:text-baseBlue text-gray-700 transition-colors duration-200"
        >
          {t("privacyPolicy")}
        </Link>
        <Link
          to={`/terms-conditions`}
          className="hover:text-baseBlue text-gray-700 transition-colors duration-200"
        >
          {t("termsAndConditions")}
        </Link>
      </div>
    </div>
  );
}

function FollowUs() {
  const { t } = useTranslation();

  return (
    <div className="text-center md:text-left">
      <h3 className="text-lg md:text-xl font-semibold mb-4 text-baseBlue flex items-center justify-center md:justify-start">
        <FaLink className="mr-2 text-baseBlue" /> {t("followUs")}
      </h3>
      <SocialNetworkLinks />
    </div>
  );
}

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="relative z-0 p-8 overflow-hidden bg-white print:hidden">
      <ShadowEffect />
      <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 px-4 md:px-8 py-4 z-10">
        <div className="text-baseBlue">
          <h2 className="text-xl text-center md:text-left md:text-2xl font-bold flex justify-center md:justify-start">
            {t("ArmWrestlingClubGarejelebi")}
          </h2>
          <div className="mt-4 text-sm text-center md:text-left">
            <p>
              &copy; 2025 {t("garejelebi")}. {t("allRightsReserved")}
            </p>
          </div>
        </div>
        <ContactInfo />
        <QuickLinks />
        <FollowUs />
      </div>
    </footer>
  );
}

export default Footer;
